import ContentSection from './components/ContentSection';
import { PrivacyPolicyWrapper } from './styles';

const PrivacyPolicy = () => {
  return (
    <PrivacyPolicyWrapper>
      <ContentSection />
    </PrivacyPolicyWrapper>
  );
};

export default PrivacyPolicy;
